import moment from "moment";
import * as momentTz from "moment-timezone";

export const DATE_FORMAT_CODE = "YYYY-MM-DD";
export const TIME_FORMAT_CODE = "HH:mm";
export const HOUR_FORMAT_CODE = "HH";

export const DATE_FORMAT_READABLE = "ddd D MMMM";
export const TIME_FORMAT_READABLE = "h:mma";

export const HOURS = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23"
];

export function formatDateReadable(date) {
  return moment(date, DATE_FORMAT_CODE).format(DATE_FORMAT_READABLE);
}

export function formatTimeReadable(time) {
  return moment(time, TIME_FORMAT_CODE).format(TIME_FORMAT_READABLE);
}

export function timestampToDateReadable(timestamp) {
  const date = momentTz(timestamp)
    .tz("GMT")
    .format(DATE_FORMAT_CODE);
  return formatDateReadable(date);
}

export function timestampToTimeReadable(timestamp) {
  const time = momentTz(timestamp)
    .tz("GMT")
    .format(TIME_FORMAT_CODE);
  return formatTimeReadable(time);
}

export function timestampToDate(timestamp) {
  if (!timestamp) return null;
  return moment(timestamp).format(DATE_FORMAT_READABLE);
}

export function timestampToTime(timestamp) {
  if (!timestamp) return null;
  return momentTz(timestamp)
    .tz("GMT")
    .format(TIME_FORMAT_READABLE);
}

export function timestampToDateAndTime(timestamp) {
  if (!timestamp) return null;
  return moment(timestamp).format(`${DATE_FORMAT_READABLE} ${TIME_FORMAT_READABLE}`);
}

export function durationInMinutesToHumanReadable(durationInMinutes) {
  if (!durationInMinutes) return "";
  if (typeof durationInMinutes === "string") return durationInMinutes;
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes - 60 * hours;
  return (
    (hours ? `${hours}hr${hours > 1 ? "s" : ""} ` : "") +
    (minutes ? `${minutes}mins` : "")
  );
}

export function rangeDates(openingDate, closingDate) {
  const dates = [];

  const opening = moment(openingDate)
    .hours(0)
    .minutes(0)
    .seconds(0);

  const closing = moment(closingDate)
    .hours(0)
    .minutes(0)
    .seconds(0);

  while (opening.diff(closing) < 0) {
    dates.push(opening.format(DATE_FORMAT_CODE));
    opening.add(1, "day");
  }

  return dates;
}

export function isTimeMorning(time) {
  return moment(time, TIME_FORMAT_CODE).isBefore({ hour: 12, minute: 0 });
}

export function isTimeEvening(time) {
  return moment(time, TIME_FORMAT_CODE).isAfter({
    hour: 17,
    minute: 59,
    second: 59
  });
}

export function isTimeAfternoon(time) {
  if (isTimeMorning(time)) return false;
  if (isTimeEvening(time)) return false;
  return true;
}

export function currentDate() {
  return moment().format(DATE_FORMAT_CODE);
}

export function hoursOutside(startTime, endTime) {
  return HOURS.filter(hour => {
    const hourTime = moment(hour, HOUR_FORMAT_CODE).format(TIME_FORMAT_CODE);
    if (hourTime < startTime) return true;
    return hourTime > endTime;
  });
}
